import React, { useEffect, useState } from "react";
import { getToken } from "../../../../utils/token";
import { useLoaderData } from "react-router-dom";
import instance from "../../../../axios/instance";
import { ArrowLeft2, ArrowRight2, SearchNormal, Sort } from "iconsax-react";
import { PaginationButton } from "../../../../components/PaginationButton";
import AddNewSpa from "../../../../components/modals/spas/AddNewSpa";
import { MedSpaConsultations } from "../../../../components/modals/spas/MedSpaConsultations";
import EditSpa from "../../../../components/modals/spas/EditSpa";

export const medSpasLoader = async () => {
  const token = getToken();
  const res = await instance.get("/doctor/med-spas", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const facility = await instance.get("/doctor/facility", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return { medSpas: res.data, facility: facility.data };
};

export const MedSpasPage = () => {
  const { medSpas, facility } = useLoaderData();
  const [medSpasList, setMedSpasList] = useState(
    [...medSpas].map((_, index) => ({ ..._, index: index + 1 }))
  );
  const [filteredSpas, setFilteredSpas] = useState(
    medSpasList.filter((_, index) => index + 1 <= 10)
  );
  const [searchQuery, setSearchQuery] = useState("");
  const [pageIndex, setPageIndex] = useState(1);
  const [sorted, setSorted] = useState("");
  const [currentSpa, setCurrentSpa] = useState(null);
  const [editSpa, setEditSpa] = useState(null);
  const [isAddSpaModalOpen, setIsAddSpaModalOpen] = useState(false);

  useEffect(() => {
    setMedSpasList(() =>
      medSpas.map((_, index) => ({ ..._, index: index + 1 }))
    );

    if (currentSpa) {
      const newSpa = medSpas.find((spa) => spa.id === currentSpa.id);
      setCurrentSpa(newSpa);
    }
  }, [medSpas]);

  const handleSearch = (e) => {
    e.preventDefault();

    const query = searchQuery.toLowerCase();
    setFilteredSpas(() => {
      return medSpasList
        .filter((spa) => {
          const name = spa.name.toLowerCase().includes(query);

          return spa.code === query || name;
        })
        .filter((_, index) => index + 1 <= 10);
    });
  };

  useEffect(() => {
    setFilteredSpas(() =>
      medSpasList.filter(
        (_, index) =>
          index + 1 > 10 * (pageIndex - 1) && index + 1 <= 10 * pageIndex
      )
    );
  }, [pageIndex, medSpasList]);

  const handleSort = (def) => {
    switch (def) {
      case "index": {
        setPageIndex(1);
        if (sorted !== "index") {
          setSorted("index");
        } else {
          setSorted("");
        }
        medSpasList.reverse();
        setMedSpasList(medSpasList);
        setFilteredSpas((items) =>
          medSpasList.filter((_, index) => index + 1 <= 10)
        );
        return;
      }
      case "name": {
        setPageIndex(1);
        if (sorted === "name") {
          setSorted("");
          medSpasList.sort((a, b) => a.index - b.index);
        } else {
          setSorted("name");
          medSpasList.sort((a, b) => {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
          });
        }
        setFilteredSpas((items) =>
          medSpasList.filter((_, index) => index + 1 <= 10)
        );
        return;
      }
      case "total": {
        setPageIndex(1);
        if (sorted === "total") {
          setSorted("");
          medSpasList.sort((a, b) => a.index - b.index);
        } else {
          setSorted("total");
          medSpasList.sort((a, b) => {
            if (a.total < b.total) return -1;
            if (a.total > b.total) return 1;
            return 0;
          });
        }
        setFilteredSpas((items) =>
          medSpasList.filter((_, index) => index + 1 <= 10)
        );
        return;
      }
      case "pending-total": {
        setPageIndex(1);
        if (sorted === "pending-total") {
          setSorted("");
          medSpasList.sort((a, b) => a.index - b.index);
        } else {
          setSorted("pending-total");
          medSpasList.sort((a, b) => {
            if (a.pending_total < b.pending_total) return -1;
            if (a.pending_total > b.pending_total) return 1;
            return 0;
          });
        }
        setFilteredSpas((items) =>
          medSpasList.filter((_, index) => index + 1 <= 10)
        );
        return;
      }
      case "date": {
        setPageIndex(1);
        if (sorted === "date") {
          setSorted("");
          medSpasList.sort((a, b) => a.index - b.index);
        } else {
          setSorted("date");
          medSpasList.sort(
            (a, b) => new Date(a.created_at) - new Date(b.created_at)
          );
        }
        setFilteredSpas((items) =>
          medSpasList.filter((_, index) => index + 1 <= 10)
        );
        return;
      }
    }
  };

  return (
    <div className="bg-[#fafafa] max-w-[100%] w-full px-7 py-5 h-[90vh] relative">
      <AddNewSpa
        isOpen={isAddSpaModalOpen}
        onClose={() => setIsAddSpaModalOpen(false)}
      />
      {editSpa && (
        <EditSpa
          isOpen={Boolean(editSpa)}
          onClose={() => setEditSpa(null)}
          spa={editSpa}
        />
      )}

      <div className="flex justify-between items-center">
        <div className="text-2xl font-bold">
         Clinic Referrals ({medSpasList.length})
        </div>

        <div className="flex gap-2 items-center">
          <button
            onClick={() => setIsAddSpaModalOpen(true)}
            className="bg-primary py-2 px-3 shadow-sm rounded-md font-medium text-[14px] hover:opacity-80 text-white"
          >
            Add Referral +
          </button>
        </div>
      </div>

      <div className="border bg-white rounded-md overflow-x-scroll scrollbar-hide mt-4">
        <div className="flex justify-between p-2 items-center">
          <form className="relative" onSubmit={handleSearch}>
            <input
              className="outline-none h-[40px] w-[300px] border rounded-md p-2 placeholder:font-normal placeholder:text-[14px] text-sm"
              placeholder="Search referral"
              name="query"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button
              className="absolute h-[38px] rounded-md top-1/2 -translate-y-1/2 right-[1px] w-[30px] flex items-center justify-center bg-white cursor-pointer hover:text-primary duration-300"
              type="submit"
            >
              <SearchNormal size={15} />
            </button>
          </form>

          <div className="flex gap-2 items-center">
            <PaginationButton
              item={<ArrowLeft2 size={16} />}
              disabled={pageIndex <= 1}
              handleClick={() => setPageIndex(pageIndex - 1)}
            />
            <span className="font-light text-xs">Page {pageIndex}</span>
            <PaginationButton
              item={<ArrowRight2 size={16} />}
              disabled={pageIndex >= Math.ceil(medSpasList.length / 10)}
              handleClick={() => setPageIndex((index) => index + 1)}
            />
          </div>
        </div>

        <div className="max-h-[80vh] overflow-y-scroll scrollbar-hide">
          <table className="w-full relative whitespace-nowrap">
            <thead>
              <tr className="uppercase h-14 font-bold bg-[#f1f1f1] text-gray-700 text-[12px]">
                <td
                  className="px-6 py-4 cursor-pointer hover:text-primary duration-300"
                  onClick={() => handleSort("index")}
                >
                  #{" "}
                  <Sort
                    size="15"
                    className={`${
                      sorted === "index" ? "rotate-180" : "rotate-0"
                    } inline`}
                    color="#FF8A65"
                  />
                </td>
                <td
                  className="px-6 py-4 cursor-pointer hover:text-primary duration-300 "
                  onClick={() => handleSort("name")}
                >
                  Name{" "}
                  <Sort
                    size="15"
                    className={`${
                      sorted === "name" ? "rotate-180" : "rotate-0"
                    } inline`}
                    color="#FF8A65"
                  />
                </td>
                <td className="px-6 py-4">Code</td>
                <td
                  className="px-6 py-4 cursor-pointer hover:text-primary duration-300"
                  onClick={() => handleSort("total")}
                >
                  Total{" "}
                  <Sort
                    size="15"
                    className={`${
                      sorted === "total" ? "rotate-180" : "rotate-0"
                    } inline`}
                    color="#FF8A65"
                  />
                </td>
                <td
                  className="px-6 py-4 cursor-pointer hover:text-primary duration-300"
                  onClick={() => handleSort("pending-total")}
                >
                  Payout Pending{" "}
                  <Sort
                    size="15"
                    className={`${
                      sorted === "pending-total" ? "rotate-180" : "rotate-0"
                    } inline`}
                    color="#FF8A65"
                  />
                </td>
                <td
                  className="px-6 py-4 cursor-pointer hover:text-primary duration-300"
                  onClick={() => handleSort("date")}
                >
                  Created On{" "}
                  <Sort
                    size="15"
                    className={`${
                      sorted === "date" ? "rotate-180" : "rotate-0"
                    } inline`}
                    color="#FF8A65"
                  />
                </td>
                <td className="px-6 py-4"></td>
              </tr>
            </thead>

            <tbody>
              {filteredSpas.length < 1 ? (
                <tr>
                  <td className="px-6 py-4 font-normal" colSpan={6}>
                    You do not have any SPA yet
                  </td>
                </tr>
              ) : (
                filteredSpas.map((spa, index) => (
                  <tr
                    key={spa.id}
                    className={`h-14 text-[14px] font-normal border-b`}
                  >
                    <td className="px-6 py-4">{spa.index}</td>
                    <td
                      className="px-6 py-4 text-primary underline cursor-pointer w-fit"
                      onClick={() => setEditSpa(spa)}
                    >
                      {spa.name}
                    </td>
                    <td
                      className="px-6 py-4 text-primary underline cursor-pointer w-fit"
                      onClick={() => setEditSpa(spa)}
                    >
                      {spa.code}
                    </td>
                    <td className="px-6 py-4">${spa.total.toLocaleString()}</td>
                    <td className="px-6 py-4">
                      ${spa.pending_total.toLocaleString()}
                    </td>
                    <td className="px-6 py-4">
                      {new Date(spa.created_at).toLocaleDateString()}
                    </td>
                    <td
                      className="px-6 py-4 underline text-primary cursor-pointer"
                      onClick={() => setCurrentSpa(spa)}
                    >
                      View
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      {currentSpa && (
        <MedSpaConsultations
          currentSpa={currentSpa}
          onClose={() => setCurrentSpa(null)}
          facility={facility}
        />
      )}
    </div>
  );
};
